import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, Output, EventEmitter, PipeTransform, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { merge, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';

import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, } from '@angular/material/snack-bar';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';

import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Location } from '@angular/common'

import * as _ from 'underscore';
import * as XLSX from 'xlsx';
declare let $: any;


@Component({
	selector: 'app-open-rgas',
	templateUrl: './open-rgas.component.html',
	styleUrls: ['./open-rgas.component.scss']
})
export class OpenRgasComponent implements OnInit, OnChanges {

	@Input() item: any = false;
	@Input() vendor: any = false;
	@Output() update_item = new EventEmitter < any > ();
	@Output() rgaloaded = new EventEmitter < any > ();
	@Output() po_data = new EventEmitter < any > ();
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('confirmCancelRga') confirmCancelRgaRef: ElementRef;

	rgas: any = [];
	allrgas: any = [];


	headercolumns: string[] = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'orddate',
		'requisitionno',
		'creditvalue',
		'creditpendingvalue',
		'credititems',
		'deliverydate',
		'initiator',

	];

	statuses: any = [];
	openRgaData: any = [];
	config: any = [];
	baselink = '';
	reclink = '';
	color = '';
	podetails: any = [];
	vendorSearch = new FormControl('');
	status= new FormControl('');
	searching = false
	search: any = false;

	// Cancel functionality
	pendingCancelRgaNo: any;
	cancelReason: any = '';
	cancelNotes: string = '';
	showReasonError: boolean = false;
	predefinedReasons: any[] = [];
	private defaultReasons = [
		{ id: '1', label: 'Customer Request', code: 'CUSTOMER_REQUEST', requires_notes: '0', sort_order: '1', is_active: '1' },
		{ id: '2', label: 'Out of Stock', code: 'OUT_OF_STOCK', requires_notes: '0', sort_order: '2', is_active: '1' },
		{ id: '3', label: 'Duplicate Order', code: 'DUPLICATE_ORDER', requires_notes: '0', sort_order: '3', is_active: '1' },
		{ id: '4', label: 'Pricing Error', code: 'PRICING_ERROR', requires_notes: '1', sort_order: '4', is_active: '1' },
		{ id: '5', label: 'Fraud Concern', code: 'FRAUD', requires_notes: '1', sort_order: '5', is_active: '1' },
		{ id: '6', label: 'Shipping Delay', code: 'SHIPPING_DELAY', requires_notes: '1', sort_order: '6', is_active: '1' },
		{ id: '7', label: 'Other', code: 'OTHER', requires_notes: '1', sort_order: '99', is_active: '1' }
	];

	constructor(private route: ActivatedRoute, private purchasingService: PurchasingService, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, public location: Location, private modalService: NgbModal, private ordersService: OrdersService) {

		this.color = this.globalSearchService.getColor();

	}

	ngOnInit(): void {
		this.config = this.globalsService.getApiConfig()
		this.baselink = this.config.apiServer.poLink;
		this.reclink = this.config.apiServer.recLink;

		// Load cancel reasons
		this.ordersService.getCancelReasons().subscribe((r: any) => {
			if (r && r.success && r.data && Array.isArray(r.data) && r.data.length > 0) {
				this.predefinedReasons = r.data;
			} else {
				this.predefinedReasons = this.defaultReasons;
			}
		}, () => {
			this.predefinedReasons = this.defaultReasons;
		});
	}

	loadData() {
		this.purchasingService.searchRgas(this.search).subscribe((results: any) => {
			this.allrgas = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.setTableData(results.pos)
		});
	}

	getStatus(id: any) {
		return this.statuses.filter((st) => {
			return parseFloat(st.status_id) == parseFloat(id)
		})[0];
	}

	setTableData(data: any) {
		this.openRgaData = data;

		this.rgas = new MatTableDataSource(data);
		this.rgas.sort = this.sort;
		this.rgas.paginator = this.paginator;
	}

	loadRga(orderno: any) {
		this.purchasingService.loadRga(orderno).subscribe((result: any) => {
			this.rgaloaded.emit(result);
		});
	}


	searchRgas() {
		const search = {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			vendor: this.vendor
		}
		this.purchasingService.searchRgas(search).subscribe((results: any) => {
			this.allrgas = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.setTableData(results.pos)
		});
	}

	updateStatus(event: any, trans: any) {

		const status_details = this.getStatus(event.value);
		const index = this.allrgas.pos.indexOf(trans)

		this.allrgas.pos[index].editing = false;
		this.allrgas.pos[index].status_id = status_details.status_id;
		this.allrgas.pos[index].statusname = status_details.name;

		this.purchasingService.updateRgaStatus(this.allrgas.pos[index]).subscribe((result: any) => {
			if(this.vendor?.supplierid){
				result.pos = result.pos.filter((o) => o.supplierno == this.vendor.supplierid);
			}
			this.allrgas = result;
			this.po_data.emit(result);
			this.statuses = result.statuses
			this.setTableData(result.pos)
		})

	}

	exportExcel() {
		this.globalSearchService.exportJsonToExcel(this.allrgas.pos, 'OpenRGAs');
	}

	toggleStatusChange(trans: any) {
		const index = this.allrgas.pos.indexOf(trans);
		if (this.allrgas.pos[index].editing) {
			this.allrgas.pos[index].editing = false;
		} else {
			this.allrgas.pos[index].editing = true;
		}
	}

	onInput() {
		//todo make this ajax call to search for items on RGAs as well
		const search = this.vendorSearch.value;
		this.searching = true;
		this.rgas = this.globalSearchService.filterItem(this.openRgaData, search, 'orderno,supplierno,deliverydate,itemcode,itemdescription,requisitionno');
		this.searching = false;
	}

	announceSortChange(event: any) {

	}

	viewRga(orderno: any, content: any) {
		this.purchasingService.getRga(orderno).subscribe((rga: any) => {
			this.podetails = rga
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}


	back(): void {
		this.location.back()
	}

	ngOnChanges(changes: any) {
		if (changes) {
			const search = {
				item: this.item,
				vendor: this.vendor,
			}

			this.purchasingService.searchRgas(search).subscribe((results: any) => {
				this.allrgas = results;
				this.po_data.emit(results);
				this.statuses = results.statuses
				this.setTableData(results.pos)
			});
		}
	}
	ngAfterViewInit() {
		//this.customers.sort = this.sort;
		//this.customers.paginator = this.paginator;
	}

	cancelRga(orderno: any) {
		this.pendingCancelRgaNo = orderno;
		this.modalService.open(this.confirmCancelRgaRef, {
			ariaLabelledBy: 'modal-title',
			size: 'md',
		});
	}

	selectReason(reason: any) {
		this.cancelReason = reason;
		this.showReasonError = false;
	}

	get reasonRequiresNote(): boolean {
		return this.cancelReason?.requires_notes === '1';
	}

	handleConfirmCancelRga(modal: any) {
		if (!this.cancelReason || (this.cancelReason === 'Other' && !this.cancelNotes.trim())) {
			this.showReasonError = true;
			return;
		}

		this.showReasonError = false;

		const payload: any = {
			orderno: this.pendingCancelRgaNo,
			reason: this.cancelReason.code || this.cancelReason,
			notes: this.cancelNotes.trim(),
			timestamp: new Date().toISOString()
		};

		this.purchasingService.cancelCredit(payload).subscribe((result: any) => {
			modal.close();
			
			if (result.success) {
				this.globalSearchService.showNotification('RGA cancelled successfully', 'success', 'bottom', 'right');
				// Reload data
				this.loadData();
			} else {
				this.globalSearchService.showNotification(result.message || 'Failed to cancel RGA', 'danger', 'bottom', 'right');
			}
		}, (error: any) => {
			modal.close();
			this.globalSearchService.showNotification('Error cancelling RGA', 'danger', 'bottom', 'right');
		});
	}

	cancelModal(modal: any) {
		modal.dismiss();
	}

}
